import api, { METHODS } from './api'
import { ResponseType } from '../common/types/api/request'

export async function getPuppeteerMainPage(): Promise<string> {
    try {
        const config = await api<{ puppeteerMainPage: string }>(`puppeteerMainPage`, METHODS.GET)
        return config.puppeteerMainPage
    } catch (error) {
        console.error("Could not get the current set value to Puppeteer Main Page in reports-maker", error)
        return ''
    }
}

export async function setPuppeteerMainPage(puppeteerMainPage: string): Promise<ResponseType> {
    try {
        const res = await api<ResponseType>(`puppeteerMainPage`, METHODS.POST, `${puppeteerMainPage}`)
        if (res.error) {
            console.error("Error trying to save new value for the Puppeteer Main Page property in reports-maker", res.error)
            return { success: false, error: res.error }
        }
        return res
    } catch (error) {
        console.error("Error trying to save new value for the Puppeteer Main Page property in reports-maker", error)
        return { success: false, error: error }
    }
}

export async function getPuppeteerHost(): Promise<string> {
    try {
        const config = await api<{ puppeteerHost: string }>(`puppeteerHost`, METHODS.GET)
        return config.puppeteerHost
    } catch (error) {
        console.error("Could not get the current set value to Live Host in reports-maker", error)
        return ''
    }
}

export async function setPuppeteerHost(puppeteerMainPage: string): Promise<ResponseType> {
    try {
        const res = await api<ResponseType>(`puppeteerHost`, METHODS.POST, `${puppeteerMainPage}`)
        if (res.error) {
            console.error("Error trying to save new value for the Live Host property in reports-maker", res.error)
            return { success: false, error: res.error }
        }
        return res
    } catch (error) {
        console.error("Error trying to save new value for the Live Host property in reports-maker", error)
        return { success: false, error: error }
    }
}
